import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const PlayButtonIcon: FC<IconProps> = props => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="36" height="36" rx="18" fill="#000624" fillOpacity="0.7" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4789 12.8067L23.3905 17.1221C23.8754 17.3866 24.054 17.994 23.7896 18.4789C23.6976 18.6474 23.5591 18.786 23.3905 18.8779L15.4789 23.1934C14.994 23.4578 14.3866 23.2792 14.1221 22.7943C14.042 22.6474 14 22.4828 14 22.3155C14 22.3155 14 19.4385 14 18C14 16.5615 14 13.6846 14 13.6846C14 13.1323 14.4477 12.6846 15 12.6846C15.1673 12.6846 15.332 12.7266 15.4789 12.8067Z"
      fill="white"
    />
  </svg>
);
